import { useEffect, useState } from 'react';

interface Breakpoint {
  isMobile: boolean;   // < 768px
  isTablet: boolean;   // 768px - 1023px
  isDesktop: boolean;  // >= 1024px
}

function getBreakpoint(): Breakpoint {
  if (typeof window === 'undefined') return { isMobile: false, isTablet: false, isDesktop: true };
  const w = window.innerWidth;
  return {
    isMobile: w < 768,
    isTablet: w >= 768 && w < 1024,
    isDesktop: w >= 1024,
  };
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState(getBreakpoint);

  useEffect(() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');

    const update = () => setBp(getBreakpoint());

    mobileQuery.addEventListener('change', update);
    tabletQuery.addEventListener('change', update);
    return () => {
      mobileQuery.removeEventListener('change', update);
      tabletQuery.removeEventListener('change', update);
    };
  }, []);

  return bp;
}
